import React, { useEffect, useState } from "react";

const LikeButton = ({ category, articleId }) => {
  const [liked, setLiked] = useState(false);
  const [likesCount, setLikesCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchLikeStatus = async () => {
      try {
        const res = await fetch(
          `https://api.todaytalks.in/api/likes/technology/6884b475721573fce417cae9/like-status`,
          {
            headers: {
              Authorization: `Bearer ${token}`
            }
          }
        );
        if (res.ok) {
          const data = await res.json();
          setLiked(data.liked);
          setLikesCount(data.likesCount);
        }
      } catch (error) {
        console.error("Error fetching like status:", error);
      }
    };
    if (token) {
      fetchLikeStatus();
    }
  }, [category, articleId, token]);

  const handleLike = async () => {
    if (!token) {
      alert("You must be logged in to like an article.");
      return;
    }
    setLoading(true);
    try {
      const res = await fetch(
        `https://api.todaytalks.in/api/likes/technology/6884b475721573fce417cae9/like`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
          }
        }
      );
      if (res.ok) {
        const data = await res.json();
        setLiked(data.liked);
        setLikesCount(data.likesCount);
      }
    } catch (error) {
      console.error("Error liking article:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      onClick={handleLike}
      disabled={loading}
      style={{
        background: "none",
        border: "none",
        cursor: "pointer",
        fontSize: "18px"
      }}
    >
      {liked ? "❤️" : "🤍"} {likesCount}
    </button>
  );
};

export default LikeButton;
